import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const HomeScreen: React.FC = () => {
  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Button
        sx={{ marginTop: '40px', fontSize: '16px', justifySelf: 'flex-start' }}
        component={Link}
        to="/flats"
        color="primary"
        variant="contained"
      >
        Explore flats
      </Button>
      <Typography pt={30} variant="h1">
        Home page
      </Typography>
    </Box>
  );
};

export default HomeScreen;
